import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const ServiceCenterRequestsListContainer = React.lazy(
  () =>
    import('../../containers/service-center-requests-list/service-center-requests-list.component')
);

const ServiceCenterRequestsDetailsContainer = React.lazy(
  () =>
    import(
      '../../containers/service-center-requests-details/service-center-requests-details.component'
    )
);

const ServiceCenterRequestsAddContainer = React.lazy(
  () => import('../../containers/service-center-requests-add/service-center-requests-add.component')
);

const ServiceCenterRequestsEditContainer = React.lazy(
  () =>
    import('../../containers/service-center-requests-edit/service-center-requests-edit.component')
);

export const ServiceCenterRequestsRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: (
      <Navigate
        to={(APP_ROUTES.SERVICE_CENTER_REQUESTS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
      />
    )
  },
  {
    path: (APP_ROUTES.SERVICE_CENTER_REQUESTS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={ServiceCenterRequestsListContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.SERVICE_CENTER_REQUESTS_MODULE.CHILDREN as RouteConfig).DETAILS.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={ServiceCenterRequestsDetailsContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.SERVICE_CENTER_REQUESTS_MODULE.CHILDREN as RouteConfig).ADD.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={ServiceCenterRequestsAddContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.SERVICE_CENTER_REQUESTS_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={ServiceCenterRequestsEditContainer}
        />
      </React.Suspense>
    )
  }
];
